// ICONS
import { Sun, Moon } from 'lucide-react';

// CONTEXT
import { useTheme } from 'context/ThemeContext';

const themes = [
    { id: 'light', label: 'Clair', icon: <Sun size={24} className="text-orange" /> },
    { id: 'dark', label: 'Sombre', icon: <Moon size={24} className="text-black/80 dark:text-light" /> },
];

export default function ThemeToggle() {
    const { theme, changeTheme } = useTheme();

    return (
        <div className="grid grid-cols-2 gap-4">
            {themes.map((item) => (
                <button
                    key={item.id}
                    onClick={() => changeTheme(item.id)}
                    className={`flex flex-col items-center justify-center p-4 rounded-lg shadow-dropping
                        ${
                        theme === item.id
                            ? 'bg-noir/60 dark:bg-gris/40 text-blanc border-transparent'
                            : 'bg-transparent hover:bg-noir/5 dark:hover:bg-blanc/10'
                        }
                    cursor-pointer`}
                >
                    {item.icon}
                    <span className="mt-2 text-body-xs">{item.label}</span>
                </button>
            ))}
        </div>
    );
}